import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, type User } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { isSelfHosted } from '../config/infra';

const noopAuth = {
  currentUser: null,
  onAuthStateChanged: (callback: (user: User | null) => void) => {
    callback(null);
    return () => undefined;
  },
} as ReturnType<typeof getAuth>;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let auth: ReturnType<typeof getAuth> = noopAuth;
let firestore: ReturnType<typeof getFirestore> = {} as ReturnType<
  typeof getFirestore
>;
let storage: ReturnType<typeof getStorage> = {} as ReturnType<
  typeof getStorage
>;

if (!isSelfHosted) {
  const app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  firestore = getFirestore(app);
  storage = getStorage(app);
}

export { auth, firestore, storage };

const firebase = {
  auth: () => auth,
  firestore: () => firestore,
  storage: () => storage,
};

export default firebase;
